module.exports = "/fast-coin/img/one.svg";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/one.svg
// module id = 2384
// module chunks = 5